import { PANEL_TYPE } from "engage/routes/CompanySettings/components/TextPanels/constants";
import { checkFontLoaded } from "../../../../utils/SimulatedItemsUtility";

const recalculatePaddingWithPx = paddingString => {
    return paddingString
        ?.split(' ')
        .map(item => item + 'px')
        .join(' ');
};

const parseLabelStyle = async (labelObject, type) => {
    if (!labelObject) {
        return {};
    }

    try {
        await checkFontLoaded(labelObject.font);
    } catch (e) {
        console.log('Font loaded failed with error:', e);
    }

    return {
        borderStyle: 'solid',
        borderWidth: labelObject.borderWidth,
        borderColor: labelObject.borderColor,
        borderRadius: labelObject.borderRadius,
        opacity: labelObject.opacity,
        color: labelObject.fontColor,
        fontFamily: `'${labelObject.font.name}'`,
        fontSize: labelObject.fontSize,
        ...(type === PANEL_TYPE.TWO_PANELS.type && { padding: recalculatePaddingWithPx(labelObject.textPadding) }),
        ...(type === PANEL_TYPE.TWO_PANELS.type && { backgroundColor: labelObject.backgroundColor }),
    };
};

export const prepareTextPanelsList = async (list) => {
    return await Promise.all(
        list.map(async textPanel => {
            const onePanelType = textPanel.type === PANEL_TYPE.ONE_PANEL.type;

            const topLabel = onePanelType ? textPanel.labelTop : textPanel.panelTop;
            const bottomLabel = onePanelType ? textPanel.labelBottom : textPanel.panelBottom;

            const topLabelStyles = await parseLabelStyle(topLabel, textPanel.type);
            const bottomLabelStyles = await parseLabelStyle(bottomLabel, textPanel.type);

            const containerStyles = {};

            if (onePanelType) {
                containerStyles.padding = recalculatePaddingWithPx(textPanel.textPadding);
                containerStyles.backgroundColor = textPanel.bgColor;
                containerStyles.borderWidth = topLabelStyles.borderWidth;
                containerStyles.borderRadius = topLabelStyles.borderRadius;
                containerStyles.borderColor = topLabelStyles.borderColor;
                containerStyles.borderStyle = topLabelStyles.borderStyle;
                containerStyles.opacity = topLabelStyles.opacity / 100;

                topLabelStyles.borderWidth = 0;
                bottomLabelStyles.borderWidth = 0;
                delete topLabelStyles.borderRadius;
                delete topLabelStyles.borderColor;
            } else {
                bottomLabelStyles.opacity = topLabelStyles.opacity / 100;
            }

            topLabelStyles.marginBottom = textPanel.spacing;

            return { ...textPanel, topLabelStyles, bottomLabelStyles, containerStyles };
        })
    );
};